import React from "react";

import _ from "lodash";

import useVisible from "../../utils/isVisible";
import lbl from "../../data/Labels.json";

import OptionIcon from "../../icons/option-icon";
import PrintIcon from "../../icons/print-icon";
import {Link} from "react-router-dom";

const StudentResultOptionsButtons = (props) => {
    const {classId, subjectId, entryYear,} = props;
    const {ref, isVisible, setIsVisible} = useVisible(false);

    const renderPrintShoqaChance1Opt = () => {
        return (
            <Link to={`/print/results/shoqa/${classId}/${subjectId}/${entryYear}?&chance=1`} target="_blank">
                <i> <PrintIcon/> </i>
                <span>{lbl.PrintShoqaChance1}</span>
            </Link>
        );
    };

    const renderPrintShoqaChance2Opt = () => {
        return (
            <Link to={`/print/results/shoqa/${classId}/${subjectId}/${entryYear}?&chance=2`} target="_blank">
                <i> <PrintIcon/> </i>
                <span>{lbl.PrintShoqaChance2}</span>
            </Link>
        );
    };

    const renderPrintShoqaChance3Opt = () => {
        return (
            <Link to={`/print/results/shoqa/${classId}/${subjectId}/${entryYear}?&chance=3`} target="_blank">
                <i> <PrintIcon/> </i>
                <span>{lbl.PrintShoqaChance3}</span>
            </Link>
        );
    };

    const renderPrintResultOpt = () => {
        return (
            <Link to={`/print/results/result/${classId}/${subjectId}/${entryYear}`} target="_blank">
                <i> <PrintIcon/></i>
                <span>{lbl.PrintResult}</span>
            </Link>
        );
    };

    const renderPrintDisqualifiedOpt = () => {
        return (
            <Link to={`/print/results/disqualified/${classId}/${subjectId}/${entryYear}`} target="_blank">
                <i> <PrintIcon/></i>
                <span>{lbl.PrintDisqualifiedStudents}</span>
            </Link>
        );
    };


    return (
        <div id={"subject-result-options"} className="row-option">
            {!_.isEmpty(props) && (
                <button className={"button circle"} onClick={() => setIsVisible(!isVisible)}>
                    <OptionIcon/>
                </button>
            )}

            {isVisible && (
                <div className="option-container " ref={ref}>
                    <ul>
                        <li>{renderPrintShoqaChance1Opt()}</li>
                        <li>{renderPrintShoqaChance2Opt()}</li>
                        <li>{renderPrintShoqaChance3Opt()}</li>
                        <li>{renderPrintDisqualifiedOpt()}</li>
                        <li>{renderPrintResultOpt()}</li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default StudentResultOptionsButtons;
